import React, { Component, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import CreateCandidateForm from '../CreateCandidateForm/CreateCandidateForm';
import Loading from '../Loading/Loading';
import Logic from '../../Logic';

const CreateCandidateModal = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    async function onCandidateCreated(values){
        let logic = new Logic();
        let baseUrl = logic.getBaseRedirectUrl();
        // values.identityNumber = logic.pad(values.identityNumber, 9, '0');
        
        setIsLoading(true);

        let res = await logic.createCandidate(values).then(response => {
            alert(response.message);
            if(response.success){
                props.onInitChanged(response.data);
                let newCandidate = response.data.user.candidates.rows.filter(a => a.identityNumber == values.identityNumber)[0]; //the newly created candidate should be first in list
                if(newCandidate.isFillFormsByAdmin){
                    if(window.confirm('האם תרצה למלא כעת את שאלון המועמד?')){
                        window.open(baseUrl + '#/edit/' + newCandidate.authKey, '_blank');
                        setIsLoading(false);
                        props.toggle();
                    }
                    else{
                        setIsLoading(false);
                        props.toggle();
                    }
                }else{
                    setIsLoading(false);
                    props.toggle();
                }
            }
            setIsLoading(false);
            return response; //return resolved;
        });
        return res; //return promise
    }

    return (
        <>
            <Loading isOpen={isLoading} />
            <Modal isOpen={props.isOpen} toggle={props.onCreateCandidateClicked}>
                <ModalHeader className="modal-close" toggle={props.toggle}>
                </ModalHeader>
                <ModalBody>
                    <CreateCandidateForm formTitle="יצירת מועמד חדש" candidate={{id:-1}} onFormSubmitted={onCandidateCreated} init={props.init}/>
                </ModalBody>
            </Modal>
        </>
    );
  };
  
  export default CreateCandidateModal;
  